import { useEffect, useRef, useState } from "react";
import { fmt } from "@/lib/format";

export const LtpCell = ({ value, digits = 2, className = "", testid }) => {
  const prev = useRef(value);
  const [flash, setFlash] = useState("");

  useEffect(() => {
    if (prev.current !== undefined && prev.current !== null && value !== null && value !== prev.current) {
      setFlash(value > prev.current ? "flash-up" : "flash-down");
      const t = setTimeout(() => setFlash(""), 600);
      prev.current = value;
      return () => clearTimeout(t);
    }
    prev.current = value;
  }, [value]);

  return (
    <span data-testid={testid} className={`num rounded px-1 ${flash} ${className}`}>
      {fmt(value, digits)}
    </span>
  );
};
